import React , { useState , useEffect, useMemo  } from "react";
import useAuth from '../../../hooks/useAuth';
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import TrainingService from '../../../services/TrainingService';

const MotorTrainingTab = ({ active }) => {
    const { user } = useAuth();
    const [showLoader, setShowLoader] = useState(true);
    const [data , setData] = useState([]);

    const trainingService = useMemo(() => new TrainingService(), []);

    const monthList = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December'
    };

    useEffect(() => {
        trainingService.getMotorTraining({ portal_user_id: user.id }).then((response) => {
            const dataResponse = response.data;

            if (dataResponse.status === 'success') {
                if (dataResponse.result.length > 0) {
                    setData(dataResponse.result);
                }
            }

        }).finally(() => {
            setShowLoader(false);
        });

    },[active, user, trainingService]);


    if (!active) return null;

    const renderNoData = () => {
        return (
            <div class="text-center my-5 fade-in">
                <div class="p-5 rounded-3 shadow-sm bg-light border mx-5">
                    <h3 class="fw-bold text-dark">Data not found.</h3>
                    
                </div>
            </div>
        )
    }
    
    const renderTrainingData = () => {
        if (showLoader) {
            return <GearSpinner />;
        }

        return (
            <React.Fragment>
                {data.length > 0 ? (
                    data.map((value, index) => (
                        <React.Fragment key={index}>
                            <div className="row mt-4">
                                <div className="col-md-12 pb-3">
                                    <div className="trainingPostTitle">
                                        <h6>{monthList[value.month]?.toUpperCase()} MOTOR OF THE MONTH TRAINING</h6>
                                        <p>Hosted By: {value.hosted_by}</p>
                                    </div>
                                    <h4>{value.title}</h4>
                                    <p>{value.short_description}</p>
                                </div>

                                <div className="col-md-12">
                                    <div className="row g-3">
                                        {value.files.length > 0 && (
                                            value.files.map((file, fileIndex) => (
                                                <React.Fragment key={fileIndex}>
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="card trainingBox">
                                                            {(file.file_type !== 'video') ? (
                                                                <a href={file.file_url} target="_blank" rel="noreferrer">
                                                                    <img src={file.thumbnail_url} alt={file.title} className="img-fluid w-100 d-block"/>
                                                                </a>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        width: "100%",
                                                                        height: "200px",
                                                                        paddingTop: "56.25%",
                                                                        overflow: "hidden"
                                                                    }}
                                                                    >
                                                                    <iframe
                                                                        title={file.title} 
                                                                        src={file.file}
                                                                        style={{
                                                                        position: "absolute",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        top: 0,
                                                                        left: 0,
                                                                        border: "none"
                                                                        }}
                                                                        allowFullScreen
                                                                        loading="lazy"
                                                                    ></iframe>
                                                                </div>
                                                            )}
                                                            <div className="card-footer">
                                                                <h6>
                                                                    {file.file_type !== 'video' ? (
                                                                        <a href={file.file_url} target="_blank" rel="noreferrer">
                                                                            {file.title}
                                                                        </a>
                                                                    ) : (
                                                                        file.title
                                                                    )}
                                                                </h6>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </React.Fragment>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>
                    ))
                ) : (
                    renderNoData()
                )}
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <div className="row tab-scroll">
                <div className="col-md-12">
                    <h5>Motor Training</h5>
                    {renderTrainingData()}	
                </div>	
            </div>
        </React.Fragment>
    );
};

export default MotorTrainingTab;